<template>
  <ankh-list :show-search-form="false">
    <template #btn-group>
      <el-button @click.native="showDialog = true">{{$t('新增')}}</el-button>
      <el-button @click.native="handleBatchDelete">{{$t('批量删除')}}</el-button>
    </template>

    <template #table="{height}">
      <table-list
          ref="list"
          :height="height"
          @query="handleSearch"
          :search-params="searchForm"
          :data="tableData"
          @selection-change="selection = $event">

        <el-table-column type="selection" width="50"/>
        <el-table-column type="index" :label="$t('序号')" width="50" fixed />

        <el-table-column prop="versionNum" :label="$t('版本号')" fixed />
        <el-table-column prop="fileName" :label="$t('安装包')" />
        <el-table-column prop="status" :label="$t('状态')">
          <template v-slot="{row}">
            <dict-text dict-flag="APK_STATUS" :status="row.status" />
          </template>
        </el-table-column>
        <el-table-column prop="createTime" :label="$t('创建时间')">
          <template v-slot="{row}">
            {{row.createTime | formatDate}}
          </template>
        </el-table-column>
        <el-table-column prop="createTime" :label="$t('上传时间')">
          <template v-slot="{row}">
            {{row.uploadTime | formatDate}}
          </template>
        </el-table-column>
        <el-table-column prop="downTime" :label="$t('下架时间')">
          <template v-slot="{row}">
            {{row.downTime | formatDate}}
          </template>
        </el-table-column>
        <el-table-column :label="$t('备注')" prop="remark" />
        <el-table-column fixed="right" :label="$t('操作')" min-width="40">
          <template v-slot="{row}">
            <div class="fb-link-flex">
              <el-link type="primary" :underline="false" @click="handleChangeStatus(row)">{{ row.status === "up" ? $t('下架') : $t('上架') }}</el-link>
              <el-link type="danger" :underline="false" @click="handleDelete(row)">{{$t('删除')}}</el-link>
            </div>
          </template>
        </el-table-column>
      </table-list>
    </template>

    <template #other>
      <el-dialog :visible.sync="showDialog" :close-on-click-modal="false"  @close="resetForm">
        <template #title>
          <h4>{{$t('新增')}}</h4>
        </template>

        <el-form label-width="auto" ref="form" :model="formData" :rules="rules">
          <el-form-item :label="$t('版本号')" prop="versionNum">
            <el-input :placeholder="$t('版本号')" v-model="formData.versionNum" />
          </el-form-item>
          <el-form-item :label="$t('备注')">
            <el-input :placeholder="$t('请输入备注')" type="textarea" :rows="5" v-model="formData.remark" />
          </el-form-item>
          <el-form-item :label="$t('安装包')">
            <el-upload
                class="upload-demo"
                ref="upload"
                accept=".apk"
                :limit="1"
                :on-success="handleSuccess"
                :on-change="handleChangeFile"
                :auto-upload="true"
                :action="$api.file.upload">
              <el-button size="small" type="primary">{{$t('选择文件')}}</el-button>
              <div slot="tip" class="el-upload__tip">{{$t('只能上传apk文件')}}</div>
            </el-upload>
          </el-form-item>
          <el-form-item :label="$t('资源包')" prop="resource">
            <upload-file accept=".wgt"
                         :action="$api.file.upload"
                         v-model="formData.resource"
                         :limit="1">
              <el-button size="small" type="primary">{{$t('选择文件')}}</el-button>
              <div slot="tip" class="el-upload__tip">{{$t('只能上传wgt文件')}}</div>
            </upload-file>
          </el-form-item>
        </el-form>

        <template #footer>
          <el-button size="small" type="primary" @click="handleAddApk">{{$t('确认')}}</el-button>
          <el-button size="small" @click="resetForm">{{$t('重置')}}</el-button>
        </template>

      </el-dialog>
    </template>
  </ankh-list>
</template>

<script>
import {request, requestByTip} from "@/config/request";
import TableList from "@/components/table-list/TableList";
import DictText from "@/components/dict/DictText";
import {resetEmpty} from "@/utils/common";
import AnkhList from "@/components/list/AnkhList.vue";
import UploadFile from "@/components/upload/UploadFile.vue";

export default {
  name: "ApkList",
  components: {UploadFile, AnkhList, DictText, TableList},
  data() {
    return {
      searchForm: {},
      tableData: [],
      selection: [],
      showDialog: false,
      formData: {
        versionNum: "",
        remark: "",
        status: "up",
        fileName: "",
        file: ""
      },
      rules: {
        versionNum: {required: true, message: this.$t('请输入版本号'), trigger: 'blur'},
        file: {required: true, message: this.$t('请上传安装包'), trigger: 'change'}
      }
    }
  },
  methods: {
    // 新增安装包
    handleAddApk() {
      const {file, resource} = this.formData;
      if(!file && !resource) {
        this.$message.error(this.$t('请上传安装包或资源包'))
        return;
      }
      this.$refs.form.validate(async (valid) => {
        if(!valid) return;
        try {
          await request(this.$api.installPackage.add, this.formData);
          this.$message.success(this.$t('操作成功'));
          this.$refs.list.handleSearch();
          this.showDialog = false;
        } catch (e) {
          console.log(e);
        }
      })
    },

    // 上传文件
    handleSuccess(res) {
      if(res.status === 200) {
        this.formData.file = res.data.code;
        this.$refs.form.clearValidate("file");
      } else {
        this.$message.error(res.desc || res.message || this.$t('上传失败'));
      }
    },

    handleChangeFile(file) {
      this.formData.fileName = file.name;
    },


    // 重置表单
    resetForm() {
     this.$refs.form.resetFields();
     resetEmpty(this.formData);
     this.formData.status = "up";
     this.$refs.upload.clearFiles();
    },

    // 上架/下架
    async handleChangeStatus(row) {
      try {
        const params = {
          code: row.code,
          status: row.status === "up" ? "down" : "up",
        }
        await request(this.$api.installPackage.updateStatus, params);
        this.$message.success(this.$t('操作成功'));
        this.$refs.list.handleRequest();
      } catch (e) {
        console.log(e);
      }
    },

    async handleDelete(row) {
      try {
        await requestByTip(this.$api.installPackage.delete, {code: row.code});
        this.$message.success(this.$t('操作成功'))
        this.$refs.list.handleRequest(1);
      } catch (e) {
        console.error(e);
      }
    },

    async handleBatchDelete() {
      if (!this.selection.length) {
        this.$message({
          type: 'warning',
          message: this.$t('未选择记录')
        });
        return;
      }
      try {
        let codes = this.selection.map(item => item.code);
        await requestByTip(
            this.$api.installPackage.batchDelete,
            codes,
            {isJson: true},
            {message: this.$t('您现在正在进行批量删除操作, 是否继续?')}
        );
        this.$message.success(this.$t('操作成功'));
        this.$refs.list.handleRequest(codes.length);
      } catch (e) {
        console.error(e);
      }
    },

    async handleSearch(params, setTotal) {
      try {
        let res = await request(this.$api.installPackage.list, params);
        for (let key in res) {
          if (res[key] instanceof Array) {
            this.tableData = res[key];
          }
        }
        setTotal(res.pager?.itemCount);
      } catch (e) {
        console.error(e);
      }
    }
  },
}
</script>

<style scoped>
/deep/ .el-dialog {
  width: 450px;
  border-radius: 10px;
}
</style>
